const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/home',
    locale: 'en',
    enableMock: (process.env.REACT_APP_DEVELOPMENT === "true") ? false : true,
}

export default appConfig
